import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { SkeletonMatchesListComponent } from '../skeleton-matches-list/skeleton-matches-list.component';

@Component({
  selector: 'app-skeleton-competition-with-matches',
  standalone: true,
  imports: [SkeletonMatchesListComponent],
  templateUrl: './skeleton-competition-with-matches.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonCompetitionWithMatchesComponent {
  nItem = input<number>(1);
  withoutMatches = input<boolean>(false);
  rowItem = computed(() => Array.from({ length: this.nItem() }, (_, i) => i));
  nSubItem = Array.from({ length: this.getRandomNumber(3) }, (_, i) => i);

  items = Array.from({ length: this.getRandomNumber(6) }, (_, i) => i);

  getRandomNumber(max: number, min: number = 1) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}
